export default "__VITE_ASSET__c254d0b2__"